import React, { useState } from "react";
import PrivacySettingsCard from "../../components-v2/profile-menu/privacy/PrivacySettingsCard";
import PrivacyPermissionsCard from "../../components-v2/profile-menu/privacy/PrivacyPermissionsCard";
import PrivacyDataManagement from "../../components-v2/profile-menu/privacy/PrivacyDataManagement";
import PrivacyActiveSessions from "../../components-v2/profile-menu/privacy/PrivacyActiveSessions";
import PrivacySecurityAlerts from "../../components-v2/profile-menu/privacy/PrivacySecurityAlerts";
import PrivacyAuditLog from "../../components-v2/profile-menu/privacy/PrivacyAuditLog";
import "../../styles-v2/profile-menu/v2-privacy-page.css";

const PrivacyPage = () => {
  /* Privacy Settings toggles */
  const [privacyToggles, setPrivacyToggles] = useState({
    profileVisibility: true,
    searchVisibility: true,
    activityStatus: true,
  });

  /* Permissions toggles */
  const [permissions, setPermissions] = useState({
    camera: false,
    microphone: false,
    location: true,
  });

  /* Security Alerts */
  const [loginAlerts, setLoginAlerts] = useState(true);

  return (
    <div className="v2-privacy-pg">
      {/* Header */}
      <div className="v2-privacy-pg__header">
        <h1 className="v2-privacy-pg__title">Privacy & Security</h1>
        <p className="v2-privacy-pg__subtitle">
          Manage your data privacy and security settings
        </p>
      </div>

      {/* Privacy Settings + Permissions (2-col) */}
      <div className="v2-privacy-pg__grid-2col">
        <PrivacySettingsCard
          privacyToggles={privacyToggles}
          setPrivacyToggles={setPrivacyToggles}
        />
        <PrivacyPermissionsCard
          permissions={permissions}
          setPermissions={setPermissions}
        />
      </div>

      {/* Data Management */}
      <PrivacyDataManagement />

      {/* Active Sessions */}
      <PrivacyActiveSessions />

      {/* Security Alerts */}
      <PrivacySecurityAlerts
        loginAlerts={loginAlerts}
        setLoginAlerts={setLoginAlerts}
      />

      {/* Audit Log */}
      <PrivacyAuditLog />
    </div>
  );
};

export default PrivacyPage;
